<template>
  <section class="section-block">
    <!-- v-if, if header is not needed do not print it -->
    <div v-if="header" class="section-block__top">
      <h2 class="section-block__header">
        {{ header }}
      </h2>
    </div>

    <div class="grid grid--two">
      <oie-static-promo-card
        v-for="promo of promoCards"
        :key="promo.id"
        :promo="promo"></oie-static-promo-card>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    promoCards: {
      type: Array,
      required: true
    },
    header: {
      type: String,
      default: ''
    }
  }
}
</script>
